module.exports = __webpack_public_path__ + "static/media/writeareview.57043309.svg";